import { Circle, Wifi, WifiOff } from 'lucide-react';

interface StatusBarProps {
  campaignName: string;
  entityCount: number;
  activeTabLabel: string;
  saveStatus: 'idle' | 'saving' | 'saved' | 'error';
  isOnline: boolean;
  theme: 'light' | 'dark';
  onToggleTheme: () => void;
}

export default function StatusBar({
  campaignName,
  entityCount,
  activeTabLabel,
  saveStatus,
  isOnline,
  theme,
  onToggleTheme,
}: StatusBarProps) {
  return (
    <div className="status-bar">
      <div className="status-bar-left">
        <span className="status-bar-item">{campaignName || 'No campaign'}</span>
        <span className="status-bar-sep" />
        <span className="status-bar-item">{entityCount} entities</span>
        <span className="status-bar-sep" />
        <span className="status-bar-item status-bar-active-tab">{activeTabLabel}</span>
      </div>
      <div className="status-bar-right">
        {saveStatus === 'saving' && (
          <span className="status-bar-item status-bar-saving">
            <span className="status-bar-spinner" />
            Saving
          </span>
        )}
        {saveStatus === 'saved' && (
          <span className="status-bar-item status-bar-saved">Saved</span>
        )}
        <span className="status-bar-item" title={isOnline ? 'Online' : 'Offline'}>
          {isOnline ? <Wifi size={11} /> : <WifiOff size={11} />}
        </span>
        <button
          type="button"
          className="status-bar-item status-bar-theme-toggle"
          onClick={onToggleTheme}
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
          <Circle size={9} className={theme === 'dark' ? 'fill-current' : ''} />
          {theme === 'dark' ? 'Dark' : 'Light'}
        </button>
      </div>
    </div>
  );
}
